const PRIVATE_KEYS=new Set(['token','access_token','refresh_token','authorization','api_key','password','secret','inspection_receipt']);
function redactActivityData(value,depth=0){
  if(depth>12)return '[nested value omitted]';
  if(Array.isArray(value))return value.map(item=>redactActivityData(item,depth+1));
  if(value && typeof value==='object')return Object.fromEntries(Object.entries(value).filter(([key])=>!PRIVATE_KEYS.has(key.toLowerCase())).map(([key,item])=>[key,redactActivityData(item,depth+1)]));
  return value;
}
module.exports={redactActivityData};
